import React from 'react'
import { useRouter } from 'next/router'
import { motion } from 'motion/react'
import { classNames } from 'src/lib/utils/helpers'
import useNavigation from 'src/lib/hooks/useNavigation'
import { NavigationItem } from '../PrimaryTabs'
import { isPathMatch } from 'src/lib/utils/path-matching'

interface SubNavigationMenuItemProps {
  subMenuItem: NavigationItem
}

const SubNavigationMenuItem = ({ subMenuItem }: SubNavigationMenuItemProps) => {
  const router = useRouter()
  const {
    getters: { sidebarOpen, isTablet }
  } = useNavigation()

  const isCurrentlySelected = isPathMatch(router.asPath, subMenuItem.path, isTablet)

  return (
    <motion.button
      layout
      onClick={() => router.push(subMenuItem.path)}
      className={classNames(
        'relative flex w-full items-center rounded-md',
        isCurrentlySelected ? 'bg-white shadow-sm text-zinc-900' : 'text-zinc-500'
      )}
      id={subMenuItem.id}
    >
      {sidebarOpen && (
        <motion.span
          layout
          className='text-text-sm-regular  w-full flex-1  text-left  hover:bg-gray-600/5 px-2 py-1 rounded-md h-7'
        >
          {subMenuItem.title}
        </motion.span>
      )}
    </motion.button>
  )
}

export default SubNavigationMenuItem
